import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueArchiveTitle: {
		id: 'issue-archival-archives.header.issue-archive-title',
		defaultMessage: 'Archived issues',
		description: 'Text which is used to show the title of the archive issues page',
	},
});
